"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../../helpers");
var configuration = {
    copyright: "Copyright \u00A9 Privalia Vendita Diretta\nSRL 2007-" + helpers_1.getCurrentYear(),
    main: [[{
                label: 'Chi siamo',
                props: {
                    href: '//it.mobile.privalia.com/private/about'
                }
            }, {
                label: 'Leggi di più su Veepee',
                props: {
                    href: '//www.veepee.it',
                    style: {
                        color: '#ec008c'
                    },
                    target: '_blank'
                }
            }], [{
                label: 'Privacy',
                props: {
                    href: '//it.mobile.privalia.com/welcome/privacy',
                    rel: 'external',
                    target: '_blank'
                }
            }, {
                label: 'Cookies',
                props: {
                    href: '//it.mobile.privalia.com/welcome/cookies',
                    rel: 'external',
                    target: '_blank'
                }
            }, {
                label: 'Condizioni d\'uso',
                props: {
                    href: '//it.mobile.privalia.com/welcome/terms',
                    rel: 'external',
                    target: '_blank'
                }
            }]]
};
exports.default = configuration;
